import {
  ArrowCounterClockwise,
  CloudCheck,
  Trash,
} from "@phosphor-icons/react";
import { lazy, Suspense } from "react";
import { useNavigate } from "react-router-dom";
import { Brand } from "../components/Brand";
import { Button } from "../components/ui/Button";
import { useToast } from "../components/ui/Toast";
import { useAssessmentSession } from "../features/session/AssessmentSessionContext";

const HeroGeometricBackground = lazy(() =>
  import("../components/HeroGeometricBackground").then((module) => ({
    default: module.HeroGeometricBackground,
  })),
);

export function AppLayout({ children }: { children: React.ReactNode }) {
  const navigate = useNavigate();
  const toast = useToast();
  const { startNew, deleteCurrent, busy } = useAssessmentSession();
  async function startOver() {
    await startNew();
    toast.show("New temporary assessment started");
    navigate("/assessment/new");
  }
  async function remove() {
    if (
      !window.confirm(
        "Delete this assessment and all uploaded evidence? This cannot be undone.",
      )
    )
      return;
    await deleteCurrent();
    navigate("/");
  }
  return (
    <div className="min-h-screen bg-[#0B0D0E] text-white">
      <div className="app-shell">
        <Suspense fallback={null}>
          <HeroGeometricBackground
            speed={0.2}
            color2="#263B12"
            className="pointer-events-none absolute inset-x-0 top-0 h-[760px] w-full opacity-25"
          />
        </Suspense>
        <header className="liquid-nav relative z-10 border-b border-white/[.09]">
          <div className="mx-auto flex max-w-[1320px] items-center justify-between gap-4 px-5 py-5 sm:px-8">
            <Brand />
            <div className="flex items-center gap-2 sm:gap-4">
              <span className="hidden items-center gap-2 text-xs font-medium text-[#70777B] sm:flex">
                <CloudCheck size={17} className="text-brand" />
                Saved securely
              </span>
              <Button
                variant="ghost"
                className="px-3"
                onClick={() => void startOver()}
                disabled={busy}
              >
                <ArrowCounterClockwise size={17} />
                <span className="hidden sm:inline">Start over</span>
              </Button>
              <Button
                variant="ghost"
                className="px-3 text-red-300"
                onClick={() => void remove()}
                disabled={busy}
              >
                <Trash size={17} />
                <span className="hidden md:inline">Delete data</span>
              </Button>
            </div>
          </div>
        </header>
        <div className="relative z-[1]">{children}</div>
      </div>
    </div>
  );
}
